export function prepareOccupations(occupations) {
    return occupations.map(prepareOccupation);
}

export function prepareOccupation(occupation) {
    return {
        ...occupation,
        id: `${occupation.general}/${occupation.specialization}`,
    };
}
